import { defineMessages } from 'react-intl';

export default defineMessages({
  copyPathButtonTooltip: {
    id: 'bitkit.file.copyPathButtonTooltip',
    description:
      'Text for tooltip when hovering over the button that copies the file path',
    defaultMessage: 'Copy file path',
  },
  fileChevronIcon: {
    id: 'bitkit.file.fileChevron',
    description: 'Text for label of file chevron',
    defaultMessage: 'Expand/collapse file',
  },
  copyButtonLabel: {
    id: 'bitkit.file.copyButtonLabel',
    description: 'Label for the copy button',
    defaultMessage: 'Copy File Path',
  },
});
